import { Mapper } from '../../../mappers';
import { SearchDefinition } from '../../../models';
import { SearchCatalog, SecurityAccess } from '../models';

export class SearchCatalogMapper extends Mapper<
  SearchCatalog,
  SearchDefinition
> {
  from(source: SearchCatalog): SearchDefinition {
    const secAccess = source.SecAccess as SecurityAccess;
    return {
      key: source.Key ?? null,
      entityType: source.EntityType,
      name: source.Name ?? '',
      description: source.Description ?? '',
      creator: {
        id: source.Creator?.Key ?? '',
        name: source.Creator?.DisplayValue ?? '',
      },
      criteria: source.Criteria,
      security: {
        read: source.SecStatus?.CanRead ?? false,
        insert: source.SecStatus?.CanCreate ?? false,
        update: source.SecStatus?.CanUpdate ?? false,
        delete: source.SecStatus?.CanDelete ?? false,
      },
      readAccess: secAccess?.Read[0]?.Key.Value,
      fullAccess: secAccess?.Write[0]?.Key.Value,
    };
  }
}
